import React, { useState, useEffect, useRef } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import './custom.css';
import { Home } from "./pages/Home";
import Admin from "./pages/Admin";
import Unauthorized from "./pages/Unauthorized";
import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";
import AuthGate from "./AuthGate";
import { setUserContext } from './telemetry/appInsights';

// Separate component for Internal users that uses useMsal
function InternalApp({ userDisplayName }) {
    const { accounts } = useMsal();
    const hasSetContext = useRef(false);

    useEffect(() => {
        if (!hasSetContext.current && accounts && accounts.length > 0) {
            const userEmail = accounts[0].username || accounts[0].name || 'unknown';
            console.log('📊 Setting Internal user context:', userEmail);
            setUserContext(userEmail, 'Internal');
            hasSetContext.current = true;
        }
    }, [accounts]);

    return (
        <AuthGate>
            <AuthenticatedTemplate>
                <Layout>
                    <Pages audience="Internal" username={userDisplayName} />
                </Layout>
            </AuthenticatedTemplate>
        </AuthGate>
    );
}

// Separate component for External/Unauthorized users
function PublicApp({ audience, userDisplayName }) {
    const hasSetContext = useRef(false);

    // Track on mount
    useEffect(() => {
        if (!hasSetContext.current) {
            const anonymousUserId = `${audience.toLowerCase()}_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
            console.log(`📊 Setting ${audience} user context:`, anonymousUserId);
            setUserContext(anonymousUserId, audience);
            hasSetContext.current = true;
        }
    }, [audience]);

    if (audience === "Unauthorized") {
        return <Unauthorized />;
    }

    return (
        <Layout>
            <Pages audience={audience} username={userDisplayName} />
        </Layout>
    );
}

// Main App component - routes to the appropriate sub-component
function App({ audience }) {
    const [userDisplayName] = useState(null);

    if (audience === "Internal") {
        return <InternalApp userDisplayName={userDisplayName} />;
    } else {
        return <PublicApp audience={audience} userDisplayName={userDisplayName} />;
    }
}

function Pages(props) {
    return (
        <Routes>
            <Route path="/" element={<Home audience={props.audience} />} />
            <Route path="/admin" element={<Admin username={props.username} audience={props.audience} />} />
        </Routes>
    )
}

export default App;